<style lang="scss">
.basic-details {
  .detail-item {
    display: flex;
    justify-content: space-between;
  }
}
</style>

<!-- eslint-disable -->
<template>
  <b-card class="basic-details">
    <b-card-title>
      Call Details
    </b-card-title>
    <slot></slot>
    <p class="detail-item sm-row-drop mb-0 text-capitalize" cy="booked-by">
      Booked By: <b>{{call.booked_by.toLowerCase() | term}}</b>
    </p>
    <p class="detail-item sm-row-drop mb-0" cy="status">
      Status: <b>{{call.status}}</b>
    </p>
    <p class="detail-item sm-row-drop mb-0" cy="visitor-name">
      Visitor Name: <b>{{call.visitor.firstname}} {{call.visitor.lastname}}</b>
    </p>
    <p class="detail-item sm-row-drop mb-0" cy="prisoner-name">
      Residents Name: <b>{{call.prisoner.firstname}} {{call.prisoner.lastname}}</b>
    </p>
    <p class="detail-item sm-row-drop mb-0" cy="prisoner-number">
      Prison or Hospital Number: <b>{{call.prisoner.prisoner_number}}</b>
    </p>
    <p class="detail-item sm-row-drop mb-0" cy="relationship">
      Relationship to Resident: <b>{{call.prisoner.relationship_to_booker}}</b>
    </p>

    <div v-if="!hideSecurityDetails">
      <p class="detail-item sm-row-drop mb-0" cy="security-band">
        Security Band: <b>{{call.security_band || 'High'}}</b>
      </p>
      <p class="detail-item sm-row-drop mb-0" cy="adult-content">
        Adult Content Setting: <b>{{call.adult_content_settings || 'Alert'}}</b>
      </p>
      <p class="detail-item sm-row-drop mb-0" cy="invalid-face">
        Invalid Face Event: <b>{{call.invalid_face_event_action || 'Pause'}}</b>
      </p>
    </div>
  </b-card>
</template>
<!-- eslint-enable -->

<script>
import {mapState} from 'vuex';

export default {
  components: {},
  props: {
    hideSecurityDetails: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  data() {
    return {
      test: '',
    };
  },
  computed: {
    ...mapState({
      prison: state => state.prison.prison,
      call: state => state.callDetails.call,
    }),
  },
  mounted() {

  },
  methods: {},
};
</script>
